module.exports = "#tef_title {\r\n    font-size: 3rem;\r\n    margin-top: 10rem;\r\n    font-weight: 600;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/congress/shared/layout/checkout/checkout-modal/checkout-modal.component.css
// module id = ./src/congress/shared/layout/checkout/checkout-modal/checkout-modal.component.css
// module chunks = main